import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

export default class WritePost extends Component {
  constructor(props) {
    super(props);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onFileAdd = this.onFileAdd.bind(this);
    this.save = this.save.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.remove = this.remove.bind(this);

    this.state = {
      post: this.props.data.post
    }
  }

  render() {
    console.log(this.props, this.state);

    return (
      <Fragment>
        <div id="new-post">
          <h1>Compose post</h1>
          <form method="post" action="/add/post" onSubmit={ this.onSubmit }>
            { this.state.post.map(function (value, i) {
                if(value.type.slice(0, 6) === "image/") return  <img className={value.type} src={ value.value } key={i} alt="user" />
                else if(value.type === "iframe") return  <iframe className={value.type} src={ value.src } key={i} title="External content"></iframe>
                else return  <p className={value.type} key={i}>{ value.value }</p>
              })
            }
            <div id="compose">
              <textarea className="text" name="text" placeholder="Type..." onKeyUp={ this.onKeyUp } cols="100" rows="1" ></textarea>
              <input className="file" type="file" multiple name="file" onChange={ this.onFileAdd } />
            </div>
            <button type="submit">Add</button>
          </form>
          { this.state.post.length ? <Fragment><Link id="next-step" to="/add/profile">Add profile</Link> or <Link id="next-step" to="/add/publish">Publish</Link></Fragment> : false }
        </div>
      </Fragment>
    )
  }
  remove(e) {
    console.log('remove ' + e.target);
  }
  onKeyUp(e) {
    e.preventDefault();
    if(e.key === "Enter") {
      this.save({ type: 'text', value: e.target.value });
      e.target.value = '';
    }
  }
  onFileAdd(e) {
    e.preventDefault();

    let files = e.target.files;
    for (let i = 0; i < files.length; i++) {

      let reader = new FileReader();
      let file = files[i];

      reader.readAsDataURL(file);
      reader.onloadend = () => {
        this.save({ type: file.type, value: reader.result } );
      }
    }

    e.target.value = null;
  }
  onSubmit(e) {
    e.preventDefault();
    this.save({ type: 'text', value: e.target.text.value });
    e.target.text.value='';
  }
  save(data) {
    let { post } = this.state;
    post.push(data);
    this.setState({ post: post }, () => this.props.onPostAdd(this.state.post));
  }
}



// WEBPACK FOOTER //
// ./src/view/new-post.jsx